<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$tc("ui.sub_account", 2)')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.account_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="account_id"
                    :placeholder='$t("ui.account_id")'
                    v-model="account_id"
                    size="sm"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
            b-row
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-2
                b-button(type="button" variant="warning" size="sm" v-b-modal.addSubAccount :disabled="$helpers.isSuspended()")
                  i.fa.fa-plus.mr-1
                  span {{ $t("ui.add_sub_account") }}
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-hover.table-bordered(show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="subAccountList" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged" thead-class="grey")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(login_id)="row")
                    span #[b {{ row.item.login_id.toUpperCase() }}]
                  template(v-slot:cell(authority_option)="row")
                    template(v-if="row.item.authority_option" v-for="item in row.item.authority_option.split(',').sort()")
                      span.label.label-inverse.ml-1.align-middle {{ $t("ui." + item) }}
                  template(v-slot:cell(status)="row")
                    div.d-flex.align-items-center.justify-content-center
                      // Block button
                      a.fas.fa-lg.fa-fw.fa-user-check.text-success.mr-1(
                        v-show="!['BLOCK','NEW'].includes(row.item.status)"
                        :title="$t('ui.block')"
                        :class="{ 'text-muted': $helpers.isSuspended() }"
                        :style="$helpers.isSuspended() ? 'cursor: not-allowed;' : 'cursor: pointer;'"
                        @click="!$helpers.isSuspended() && subAccountBlock(row.item)"
                      )
                      // Unblock button
                      a.fas.fa-lg.fa-fw.fa-user-slash.text-danger.mr-1(
                        v-show="row.item.status == 'BLOCK'"
                        :title="$t('ui.unblock')"
                        :class="{ 'text-muted': $helpers.isSuspended() }"
                        :style="$helpers.isSuspended() ? 'cursor: not-allowed;' : 'cursor: pointer;'"
                        @click="!$helpers.isSuspended() && subAccountUnblock(row.item)"
                      )
                      // Status badges
                      span.width-50.badge.badge-success.align-middle(
                        v-show="row.item.status == 'ACTIVE'"
                      ) {{ $t('ui.active').toUpperCase() }}
                      span.width-50.badge.badge-info.align-middle(
                        v-show="row.item.status == 'NEW'"
                      ) {{ $t('ui.new').toUpperCase() }}
                      span.width-50.badge.badge-danger.align-middle(
                        v-show="row.item.status == 'RESET'"
                      ) {{ $t('ui.reset').toUpperCase() }}
                  template(v-slot:cell(created_date)="row")
                    span {{ $moment(row.item.created_date).format("YYYY-MM-DD hh:mm:ss") }}
                  template(v-slot:cell(action)="row")
                    div.d-flex.flex-nowrap(style="justify-content: center;")
                      span
                        template(v-if="$helpers.isSuspended()")
                          a.fas.fa-lg.fa-fw.fa-lock.text-warning(
                            style="cursor: pointer;"
                          )
                        template(v-else)
                          a.fas.fa-lg.fa-fw.fa-lock.text-warning(
                            v-b-modal.resetPassword
                            @click="setEditSelectedModal(row.item)"
                            :title="$t('ui.password')"
                            style="cursor: pointer;"
                          )
                      span
                        template(v-if="$helpers.isSuspended()")
                          a.fas.fa-lg.fa-fw.fa-tasks.text-alert(
                            style="cursor: pointer;"
                          )
                        template(v-else)
                          a.fas.fa-lg.fa-fw.fa-tasks.text-alert(
                            v-b-modal.updateAuthority
                            @click="setEditSelectedModal(row.item)"
                            :title="$t('ui.authority_option')"
                            style="cursor: pointer;"
                          )

      addSubAccount(@clicked="submit")
      resetPasswordSub(:accountId="updateLoginID" @clicked="submit")
      updateSubAccount(:accountId="updateLoginID" @clicked="submit")
      updateAuthority(:accountId="updateLoginID" @clicked="submit")
</template>

<script>
import SubmitButton from "@/library/SubmitButton"
import addSubAccount from "@/components/modal/addSubAccount.vue"
import updateSubAccount from "@/components/modal/updateSubAccount.vue"
import updateAuthority from "@/components/modal/updateAuthority.vue"
import resetPasswordSub from "@/components/modal/resetPasswordSub.vue"
import DebounceInput from "@/library/DebounceInput"

export default {
  components: {
    SubmitButton,
    addSubAccount,
    updateSubAccount,
    updateAuthority,
    resetPasswordSub,
    DebounceInput
  },
  data() {
    return {
      account_id: "",
      subAccountList: [],
      updateLoginID: "",
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      filter: null,
      sortBy: "account_id",
      sortDesc: false,
      currentPage: 1,
      totalRows: 0
    }
  },
  validations: {},
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "bg-grey"
        },
        {
          key: "login_id",
          label: this.$t("ui.login_id"),
          class: "align-middle",
          sortable: true,
          thClass: "bg-grey"
        },
        {
          key: "action",
          label: this.$t("ui.action"),
          class: "align-middle text-center",
          thClass: "bg-grey"
        },
        {
          key: "status",
          label: this.$t("ui.status"),
          class: "align-middle text-center",
          thClass: "bg-grey"
        },
        {
          key: "authority_option",
          label: this.$t("ui.authority_option"),
          class: "align-middle text-center",
          thClass: "bg-grey"
        },
        {
          key: "last_login_ip",
          label: this.$t("ui.login_ip"),
          class: "align-middle",
          sortable: true,
          thClass: "bg-grey"
        },
        {
          key: "created_date",
          label: this.$t("ui.created_on"),
          sortable: true,
          class: "align-middle text-right",
          thClass: "bg-grey"
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    }
  },
  mounted: function(){
    this.submit()
  },
  methods: {
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable()
    },
    refreshTable() {
      this.$root.$emit("bv::table::refresh", "tblList")
    },
    setEditSelectedModal: function(account) {
      this.updateLoginID = account.login_id
    },
    subAccountBlock: function(account) {
      this.$swal({
        title: this.$t("ui.status"),
        text: this.$t("message.block_sub_account_confirm"),
        type: "warning",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          let sub_login_id = account.login_id
          this.loading = true
          this.$store
            .dispatch("user/subAccountBlock", { sub_login_id })
            .then(response => {
              this.loading = false
              this.submission.success = response.success
              // this.submission.status = response.errorTag
              if (this.submission.success == true) {
                this.$swal({
                  title: this.$t("ui.succeed"),
                  text: this.$t("message.block_sub_account_success"),
                  type: "success",
                  allowOutsideClick: false
                }).then(isConfirm => {
                  if (isConfirm) {
                    this.submit();
                  }
                });
              }
            })
            .catch(response => {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = this.$t("message." + response.errorTag)
            });
        } else if (
          // Read more about handling dismissals
          result.dismiss === 'cancel'
        ) {
          this.loading = false
          this.$swal({
            title: this.$t("ui.cancel"),
            text: this.$t("message.block_sub_account_cancel"),
            type: "error",
            allowOutsideClick: false
          }).then(isConfirm => {
            if (isConfirm) {
              this.submit()
            }
          });
        }
      });
    },
    subAccountUnblock: function(account) {
      this.$swal({
        title: this.$t("ui.status"),
        text: this.$t("message.unblock_sub_account_confirm"),
        type: "warning",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          let sub_login_id = account.login_id
          this.loading = true
          this.$store
            .dispatch("user/subAccountUnblock", { sub_login_id })
            .then(response => {
              this.loading = false
              this.submission.success = response.success
              // this.submission.status = response.errorTag
              if (this.submission.success == true) {
                this.$swal({
                  title: this.$t("ui.succeed"),
                  text: this.$t("message.unblock_sub_account_success"),
                  type: "success",
                  allowOutsideClick: false
                }).then(isConfirm => {
                  if (isConfirm) {
                    this.submit();
                  }
                });
              }
            })
            .catch(response => {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = this.$t("message." + response.errorTag)
            });
        } else if (
          // Read more about handling dismissals
          result.dismiss === 'cancel'
        ) {
          this.loading = false
          this.$swal({
            title: this.$t("ui.cancel"),
            text: this.$t("message.unblock_sub_account_cancel"),
            type: "error",
            allowOutsideClick: false
          }).then(isConfirm => {
            if (isConfirm) {
              this.submit()
            }
          });
        }
      });
    },
    submit: function() {
      if (!this.$v.$invalid) {
        let search_id = this.account_id
        let start_date = "";//(this.dateRange[0] != null) ? ((this.dateRange[0] != "") ? this.$moment(this.dateRange[0]).format("YYYY-MM-DD") : "") : "";
        let end_date = "";//(this.dateRange[1] != null) ? ((this.dateRange[1] != "") ? this.$moment(this.dateRange[1]).format("YYYY-MM-DD") : "") : "";
        let page_number = this.currentPage;
        this.currentPage = parseInt(page_number);
        let page_size = this.perPage;
        let sort_key = this.sortBy;
        let sort_type = this.direction;
        this.loading = true
        this.$store
          .dispatch("user/getSubAccountList", { search_id, start_date, end_date, page_number, page_size, sort_key, sort_type })
          .then(response => {
            this.loading = false
            this.submission.success = response.success;
            // this.submission.status = response.errorTag;
            if (this.submission.success == true) {
              this.subAccountList = response.data
              this.totalRows = response.data.length > 0 ? this.subAccountList[0]["totalrows"] : 0;
            }
          })
          .catch(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    }
  }
}
</script>